module.exports = __webpack_public_path__ + "img/gartek-services-plumbing.60686380.jpeg";